import _ from 'lodash';
import { ref } from '@vue/composition-api';
import { $api } from '@/store/ApiClient';
import { generateUuid, mapToSchemaList } from '@/utils/searchUtil.js';
import { tradingManageSearchResSample } from '@/sampleData/tradingManageSearchResSample.js';

// const isMock = true;
const isMock = false;

export function useBffTradingManagesSearch(
  initialQueries = {},
  immediate = true,
  tradingFlowId,
) {
  const data = ref(null);
  const tradingInfo = ref(null);
  const flowInfo = ref(null);
  const processData = ref(null);
  const loading = ref(false);
  const error = ref(null);
  const cancelRequestSources = [];
  const tag = generateUuid();
  cancelRequestSources.push(tag);

  // tradingId: T202505190000003

  const entityName = {
    1: 'CONTRACT',
    2: 'LC',
    3: 'TRANSPORTATION_AG',
    4: 'EX_CUSTOMS',
    5: 'TRANSPORTATION',
    6: 'MARINE_I',
    7: 'FINAL_DOCS',
    8: 'COMBINED',
  };

  const entityColors = {
    CONTRACT: { startColor: '#9B2AD0', stopColor: '#DB8EFF' },
    LC: { startColor: '#29EEE2', stopColor: '#0799A3' },
    TRANSPORTATION_AG: { startColor: '#1C0898', stopColor: '#516BF2' },
    EX_CUSTOMS: { startColor: '#4EB100', stopColor: '#C8E416' },
    TRANSPORTATION: { startColor: '#83F0FF', stopColor: '#0766D6' },
    MARINE_IP: { startColor: '#EA5478', stopColor: '#FF98E2' },
    FINAL_DOCS: { startColor: '#FFD646', stopColor: '#FE7122' },
    COMBINED: { startColor: '#A60606', stopColor: '#FF1313' },
  };

  const fetchData = async (
    queries = initialQueries,
    flowId = tradingFlowId,
  ) => {
    loading.value = true;
    error.value = null;
    const params = {
      lslConfig: {
        serviceCode: 'tw-transaction-bff-api',
        apiCode: 'get_/v1/tradings/manages/search',
        query: queries,
      },
      tag: cancelRequestSources,
    };
    try {
      if (isMock) {
        setTimeout(() => {
          data.value = tradingManageSearchResSample;
          tradingInfo.value = tradingManageSearchResSample.tradingInfo;
          if (flowId !== 'new') {
            flowInfo.value = tradingManageSearchResSample.tradingInfo.tradingFlowList.find(
              flow => flow.tradingFlowId === flowId,
            );

            processData.value = mapToSchemaList(flowInfo.value);
          }
        }, 2000);
      } else {
        const res = await $api.request(params);
        data.value = res;

        tradingInfo.value = res.tradingInfo;
        if (flowId !== 'new') {
          flowInfo.value = res.tradingInfo.tradingFlowList.find(
            flow => flow.tradingFlowId === flowId,
          );

          processData.value = mapToSchemaList(flowInfo.value);
        }
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };

  if (immediate) fetchData();

  return {
    data,
    tradingInfo,
    flowInfo,
    processData,
    loading,
    error,
    fetchData,
    refresh: fetchData,
  };
}
